// Observer for navigation
const observer = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      const intersecting = entry.isIntersecting;
      if (intersecting) {
        document.querySelector("#brave-box__atc-footer").style.transform =
          "translateY(0px)";
      }
    });
  },
  { rootMargin: "-50%" }
);
const staticAtcButton = document.getElementById(
  "brave-box__product-section-atc"
);
observer.observe(staticAtcButton);

const updatePopout = (sections) => {
  let cartDrawerEl = document.querySelector("#CartDrawer");
  let html = new DOMParser()
    .parseFromString(sections["cart-drawer"], "text/html")
    .querySelector("#CartDrawer").innerHTML;
  cartDrawerEl.innerHTML = html;
  let bubbleEl = document.querySelector("#cart-icon-bubble");
  bubbleEl.innerHTML = sections["cart-icon-bubble"];
};

const atcButtons = document.querySelectorAll(".brave-box__atc");
atcButtons.forEach((button) => {
  button.addEventListener("click", () => {
    button.innerHTML = "Adding...";
    let formData = {
      items: [
        {
          quantity: 1,
          id: 45253591466242,
          selling_plan: 3010199810,
          form_type: "product",
          properties: {
            _custom_order_tag: button.getAttribute("aria-custom-order-tag")
          }
        },
        // {
        //   quantity: 1,
        //   id: 45773957169410,
        //   form_type: "product"
        // }
      ],
      sections: "cart-drawer,cart-icon-bubble",
    };
    $.ajax({
      type: "POST",
      url: "/cart/add",
      dataType: "json",
      data: formData,
      success: async function (res) {
        button.innerHTML = "Added";
        updatePopout(res.sections);
        setTimeout(() => {
          document
            .querySelector("#cartDrawerContainer")
            .classList.add("active");
        }, 500);
        button.removeAttribute("disabled", "");
      },
    }).fail(function (e) {
      return window.location.reload(), !1;
    });
  });
});
